<template>
  <div class="image" :class="height > width ? 'vertical' : ''">
    <FileLimitDesc v-bind="imageInfo">
      <template slot="btn" v-if="showBtn">
        <el-button type="primary" @click="$emit('upload', 'image')">选择图片</el-button>
      </template>
    </FileLimitDesc>
    <slot name="material-type">
      <el-tag class="badge">图片{{ index + 1 }}</el-tag>
    </slot>
    <img style="height: 100%" v-if="$attrs.preview_url" :src="$attrs.preview_url" alt="" />
    <i class="remove el-icon-error" @click="$emit('remove')"></i>

    <div class="asset-name">
      <p v-if="width">
        <el-tag type="info">{{ width }}&times;{{ height }}</el-tag>
      </p>
      <p v-if="size">
        <el-tag type="info">{{ (size / 1024 / 1024).toFixed(2) }}M</el-tag>
      </p>
      <p>
        <el-tag type="info">{{ $attrs.name }}</el-tag>
      </p>
    </div>
  </div>
</template>

<script>
import FileLimitDesc from './material-desc'
export default {
  components: { FileLimitDesc },
  // props: ['width', 'height', 'index', 'showBtn'],
  props: {
    width: Number,
    height: Number,
    index: Number,
    size: Number,
    showBtn: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },
  computed: {
    imageInfo() {
      return {
        description: '图片',
        width: this.width,
        height: this.height,
        file_size: 1024 * 1,
        file_format: ['JPG', 'PNG']
      }
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
@import './styles.scss';
</style>
